import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/login.jpg'


const _hoisted_1 = {
  key: 0,
  class: "row align-items-center"
}
const _hoisted_2 = { class: "col-lg-6" }
const _hoisted_3 = { class: "mw-480 ms-lg-auto" }
const _hoisted_4 = {
  key: 0,
  class: "fs-28 mb-2"
}
const _hoisted_5 = {
  key: 1,
  class: "fw-medium fs-16 mb-4"
}
const _hoisted_6 = {
  key: 2,
  class: "text-center mb-4"
}
const _hoisted_7 = {
  key: 0,
  class: "alert alert-success d-flex align-items-center",
  role: "alert"
}
const _hoisted_8 = {
  key: 1,
  class: "alert alert-danger d-flex align-items-center",
  role: "alert"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "form-floating mb-4" }
const _hoisted_11 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_12 = { class: "form-group mb-4" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_15 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center py-1"
}
const _hoisted_16 = {
  key: 3,
  class: "text-center"
}
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 0,
  class: "alert alert-success d-flex align-items-center",
  role: "alert"
}
const _hoisted_21 = {
  key: 1,
  class: "alert alert-danger d-flex align-items-center",
  role: "alert"
}
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "form-floating mb-4" }
const _hoisted_24 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_25 = { class: "form-group mb-4" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_28 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center py-1"
}
const _hoisted_29 = {
  key: 3,
  class: "text-center"
}
const _hoisted_30 = {
  key: 0,
  class: "text-muted small mb-3"
}
const _hoisted_31 = {
  key: 4,
  class: "form-group"
}
const _hoisted_32 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["m-auto", { 'm-1230': !_ctx.isModal }])
  }, [
    (!_ctx.isModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-lg-6 d-none d-lg-block" }, [
            _createElementVNode("img", {
              src: _imports_0,
              class: "rounded-3",
              alt: "forgot password"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (!_ctx.isModal)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_4, "Password Dimenticata?"))
                : _createCommentVNode("", true),
              (!_ctx.isModal)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Inserisci il tuo indirizzo email e ti invieremo un link per reimpostare la password. "))
                : _createCommentVNode("", true),
              (_ctx.isModal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("h4", { class: "mb-2" }, "Password Dimenticata?", -1),
                    _createElementVNode("p", { class: "text-muted" }, " Inserisci la tua email per ricevere il link di reset ", -1)
                  ]))]))
                : _createCommentVNode("", true),
              _createElementVNode("form", {
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleForgotPassword && _ctx.handleForgotPassword(...args)), ["prevent"])),
                class: "auth-form"
              }, [
                (_ctx.successMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _cache[13] || (_cache[13] = _createElementVNode("i", { class: "material-symbols-outlined me-2" }, "check_circle", -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.successMessage), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.apiError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _cache[14] || (_cache[14] = _createElementVNode("i", { class: "material-symbols-outlined me-2" }, "error", -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.apiError), 1)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.emailSent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          class: _normalizeClass(["form-control h-55", { 'is-invalid': _ctx.emailError }]),
                          id: "forgotEmail",
                          placeholder: "esempio@email.com",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validateEmail && _ctx.validateEmail(...args))),
                          onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.validateEmail && _ctx.validateEmail(...args))),
                          required: ""
                        }, null, 34), [
                          [_vModelText, _ctx.email]
                        ]),
                        _cache[15] || (_cache[15] = _createElementVNode("label", { for: "forgotEmail" }, "Indirizzo Email", -1)),
                        (_ctx.emailError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.emailError), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("button", {
                          type: "submit",
                          class: "btn btn-primary fw-medium py-2 px-3 w-100",
                          disabled: !_ctx.isFormValid || _ctx.isLoading
                        }, [
                          (_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[16] || (_cache[16] = [
                                _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                              ]))]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[17] || (_cache[17] = [
                                _createElementVNode("i", { class: "material-symbols-outlined text-white fs-20 me-2" }, "email", -1),
                                _createElementVNode("span", null, "Invia link di reset", -1)
                              ]))]))
                        ], 8, _hoisted_13)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _cache[18] || (_cache[18] = _createElementVNode("p", { class: "mb-4" }, " Controlla la tua casella di posta elettronica e clicca sul link che ti abbiamo inviato per reimpostare la password. ", -1)),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-primary fw-medium py-2 px-3",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
                      }, " Invia di nuovo ")
                    ])),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("p", _hoisted_18, [
                    _cache[20] || (_cache[20] = _createTextVNode(" Ti sei ricordato la password? ", -1)),
                    _createVNode(_component_RouterLink, {
                      to: "/authentication/login",
                      class: "fw-medium text-primary text-decoration-none"
                    }, {
                      default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                        _createTextVNode(" Torna al Login ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ], 32)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "text-center mb-4" }, [
            _createElementVNode("h4", { class: "mb-2" }, "Password Dimenticata?"),
            _createElementVNode("p", { class: "text-muted" }, " Inserisci la tua email per ricevere il link di reset ")
          ], -1)),
          _createElementVNode("form", {
            onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleForgotPassword && _ctx.handleForgotPassword(...args)), ["prevent"])),
            class: "auth-form"
          }, [
            (_ctx.successMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _cache[22] || (_cache[22] = _createElementVNode("i", { class: "material-symbols-outlined me-2" }, "check_circle", -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.successMessage), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.apiError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _cache[23] || (_cache[23] = _createElementVNode("i", { class: "material-symbols-outlined me-2" }, "error", -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.apiError), 1)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.emailSent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      class: _normalizeClass(["form-control h-55", { 'is-invalid': _ctx.emailError }]),
                      id: "modalForgotEmail",
                      placeholder: "esempio@email.com",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.email) = $event)),
                      onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.validateEmail && _ctx.validateEmail(...args))),
                      onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.validateEmail && _ctx.validateEmail(...args))),
                      required: ""
                    }, null, 34), [
                      [_vModelText, _ctx.email]
                    ]),
                    _cache[24] || (_cache[24] = _createElementVNode("label", { for: "modalForgotEmail" }, "Indirizzo Email", -1)),
                    (_ctx.emailError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.emailError), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: "btn btn-primary fw-medium py-2 px-3 w-100",
                      disabled: !_ctx.isFormValid || _ctx.isLoading
                    }, [
                      (_ctx.isLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [...(_cache[25] || (_cache[25] = [
                            _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                          ]))]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_28, [...(_cache[26] || (_cache[26] = [
                            _createElementVNode("i", { class: "material-symbols-outlined text-white fs-20 me-2" }, "email", -1),
                            _createElementVNode("span", null, "Invia link di reset", -1)
                          ]))]))
                    ], 8, _hoisted_26)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _cache[27] || (_cache[27] = _createElementVNode("p", { class: "mb-4" }, " Email inviata! Controlla la tua casella di posta. ", -1)),
                  (_ctx.isModal && _ctx.countdown > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_30, " Tornerai automaticamente al login tra " + _toDisplayString(_ctx.countdown) + " secondi ", 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-primary fw-medium py-2 px-3 me-2",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
                  }, " Invia di nuovo "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-link fw-medium py-2 px-3",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('switch-to-login')))
                  }, " Torna al Login ")
                ])),
            (!_ctx.emailSent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("p", _hoisted_32, [
                    _cache[28] || (_cache[28] = _createTextVNode(" Ti sei ricordato la password? ", -1)),
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.$emit('switch-to-login')), ["prevent"])),
                      class: "fw-medium text-primary text-decoration-none"
                    }, " Torna al Login ")
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}